import { ChecklistModuleType } from '../types';

export interface ITypeAssociation {
  type: ChecklistModuleType;
  display: string;
}

export const TYPE_ASSOCIATIONS: ITypeAssociation[] = [
  {
    type: 'ChecklistManagement::Modules::BooleanModule',
    display: $localize`Boolesch`,
  },
  {
    type: 'ChecklistManagement::Modules::NumberModule',
    display: $localize`Zahl`,
  },
  {
    type: 'ChecklistManagement::Modules::StringModule',
    display: $localize`Kurztext`,
  },
  {
    type: 'ChecklistManagement::Modules::TextareaModule',
    display: $localize`Langtext`,
  },
  {
    type: 'ChecklistManagement::Modules::SelectModule',
    display: $localize`Auswahlfeld`,
  },
  {
    type: 'ChecklistManagement::Modules::GalleryModule',
    display: $localize`Bilder-Upload`,
  },
  {
    type: 'ChecklistManagement::Modules::DateModule',
    display: $localize`Datumsfeld`,
  },
];
